<template v-if="ready">
    <b-card class="mb-2"  v-if="notifications.length > 0">
        <b-card-header class="text-white mb-2" :class="bgcolor">
            <div>
                <i class="fa-solid fa-bell me-1"></i><small>{{ $t('Last') }} {{ $t(state) }} {{ $t('alerts') }}</small>
            </div>
            <small>{{ $t('(max entries: 25)')}}</small>
        </b-card-header>
        <b-card-body style="height:200px;overflow-y:auto;">
            <div v-if="notifications.length === 0">
                <b-list-group :class="[bgborder]">
                    <b-list-group-item v-if="!error">
                        <h6 class="mb-2">{{ $t('noitems') }}</h6>
                    </b-list-group-item>
                    <b-list-group-item v-if="error">
                        <h6 class="mb-2">{{ $t('request error') }}</h6>
                    </b-list-group-item>
                </b-list-group>
            </div>
            <div v-if="notifications.length > 0">
                <b-list-group v-for="notification in notifications" :key="notification.Service.id">
                    <b-list-group-item class="mb-2" :class="[bgborder]">
                        <b-row>
                            <b-col cols="4">
                                <small><b>{{$t('Host')}}</b></small>
                            </b-col>
                            <b-col><small>
                                {{notification.Host.name}}
                                <router-link
                                    :to="{name: 'hostsDetails', params: {id: notification.Host.id}}" v-if="hostPermission">
                                    <i class="fa-solid fa-eye"></i>
                                </router-link>
                            </small></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4"><small><b>{{$t('Service')}}</b></small></b-col>
                            <b-col><small>
                                {{notification.Service.servicename}}
                                <router-link
                                    :to="{name: 'servicesDetails', params: {id: notification.Service.id}}" v-if="servicePermission">
                                    <i class="fa-solid fa-eye"></i>
                                </router-link>
                            </small></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4"><small><b>{{$t('Last date')}}</b></small></b-col>
                            <b-col><small>{{notification.NotificationService.start_time}}</small></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4"><small><b>{{$t('Count')}}</b></small></b-col>
                            <b-col><small>{{notification.count}}</small></b-col>
                        </b-row>

                    </b-list-group-item>
                </b-list-group>
            </div>
        </b-card-body>
    </b-card>
</template>
<script>
import { useToast } from 'vue-toastification';
import { BListGroup } from 'bootstrap-vue-next';

export default {
    name: "ServiceAlertWidget",
    components: {BListGroup},
    props: ['state'],
    data() {
        return {
            ready: false,
            error: false,
            notifications: [],
            scroll: {},
            bgcolor: '',
            bgborder:'',
            currentPage: 1,
            not_older_than: 1440, //time in Minutes tol look back for notifications
            filter: {
                filter: {
                    state: [this.state],
                    not_older_than: 1440
                }
            }
        }
    },
    mounted() {
        this.getColor();
        this.getNotifications();
    },
    methods: {
        getColor: function() {
            switch (this.state) {
                case 'unknown':
                    this.bgcolor = 'bg-unknown';
                    this.bgborder = 'b-unknown';
                    break;
                case 'critical':
                    this.bgcolor = 'bg-critical';
                    this.bgborder = 'b-critical';
                    break;
                case 'warning':
                    this.bgcolor = 'bg-warning';
                    this.bgborder = 'b-warning';
                    break;
                case 'ok':
                    this.bgcolor = 'bg-ok';
                    this.bgborder = 'b-ok';
                    break;
                default:
                    this.bgcolor = 'bg-primary';
            }
        },

        getNotifications: function(page = 1) {
            this.error = false;
            axios.post('/notifications/serviceNotifications.json', {
                filter: this.filter,
                page: page}, {}
            ).then(response => {
                    this.notifications = response.data.notifications.all_notifications ?? [];
                    this.ready = true;
            })
                .catch(error => {
                    this.error = true;
                })
                .finally(() => {
                });
        }
    },
    computed: {
        hostPermission() {
            if(this.$store.state.permissions.hosts && this.$store.state.permissions.hosts.browser) {
                return true;
            }
            return false;
        },
        servicePermission() {
            if(this.$store.state.permissions.services && this.$store.state.permissions.services.browser) {
                return true;
            }
            return false;
        }
    }
}
</script>

<style scoped>
.b-ok {
    border: medium solid #00C851 !important;
}
.b-warning {
    border: medium solid #ffbb33 !important;
}
.b-critical {
    border: medium solid #CC0000 !important;
}
.b-unknown {
    border: medium solid #727b84 !important;
}

</style>